import { AxiosHttpService } from 'services/AxiosHttpService';
import { BreakRuleRepository } from 'repository/timekeeper/BreakRuleRepo';
import { CombinationRuleRepository } from 'repository/timekeeper/CombinationRepo';
import { CreditHolidayRuleRepo } from 'repository/timekeeper/CreditHolidayRuleRepo';
import { FixedRuleRepo } from 'repository/timekeeper/FixedRuleRepo';
import { HolidayRepository } from 'repository/timekeeper/HolidayRepo';
import { InterpretationRulesRepository } from 'repository/timekeeper/InterpretationRuleRepo';
import { ZoneRepo } from 'repository/timekeeper/ZoneRepo';
import { WorkRuleRepository } from 'repository/timekeeper/WorkRuleRepo';
import { ScheduleDesviationRepo } from 'repository/timekeeper/ScheduleDesviationRepo';
import { PaycodeRepository } from 'repository/timekeeper/PaycodeRepo';
import { OvertimeRepository } from 'repository/timekeeper/OvertimeRepo';
import { PayRuleRepository } from 'repository/timekeeper/PayRuleRepo';
import { BonusRuleRepository } from 'repository/timekeeper/BonusRuleRepo';
import { ExceptionRuleRepo } from 'repository/timekeeper/ExceptionRuleRepo';
import { PaycodesDistributionsRepository } from 'repository/timekeeper/PaycodesDistributionsRepo';
import { PunchMatchRepository } from 'repository/timekeeper/PunchMatch';
import { PunchRepository } from 'repository/timekeeper/PunchRepo';
import { TotalizeRepository } from 'repository/timekeeper/Totalize';
import { RoundingRulesRepo } from 'repository/timekeeper/RoundingRules';
import { PaycodesCombinationRepository } from 'repository/timekeeper/PaycodesCombinationRepo';
import { AccrualCodeRepository } from 'repository/timekeeper/AccrualCodeRepo';
import { createApiClient } from 'utils/AxiosClient';
import { ICacheService } from './ICacheService';
import { CacheService } from 'services/CacheService';
import { AccrualDateRepository } from 'repository/timekeeper/AccrualDatesRepo';
import { DatePatternRepository } from 'repository/timekeeper/DatePatternRepo';
import { GroupBalanceRepository } from 'repository/timekeeper/GroupBalanceRepo';
import { BalanceDominoRepository } from 'repository/timekeeper/BalanceDomino';
import { GrantRepository } from 'repository/timekeeper/GrantsRepo';
import { LimitRepository } from 'repository/timekeeper/LimitsRepo';
import { AccrualProfileRepository } from 'repository/timekeeper/AccrualProfilesRepo';
import { AccrualRuleRepository } from 'repository/timekeeper/AccrualRulesRepo';
import { EmployeeAccrualProfileRepository } from 'repository/timekeeper/EmployeeAccrualProfileRepo';
import { ConfigSystemRepository } from 'repository/timekeeper/ConfigSystemRepo';

export class TimekeeperService {

    private cacheService: ICacheService;
    private httpTKService: IHttpService;
    private httpAccrualService: IHttpService;
    private httpPunchService: IHttpService;

    public break_rule: BreakRuleRepository
    public combination_rule: CombinationRuleRepository
    public credit_holiday_rule: CreditHolidayRuleRepo
    public fixed_rule: FixedRuleRepo
    public holiday: HolidayRepository
    public interpretation_rules: InterpretationRulesRepository
    public zones: ZoneRepo
    public work_rules: WorkRuleRepository
    public schedule_desviation: ScheduleDesviationRepo
    public paycodes: PaycodeRepository
    public overtime: OvertimeRepository
    public payrules: PayRuleRepository
    public bonus_rules: BonusRuleRepository
    public exception_rules: ExceptionRuleRepo
    public paycode_distributions: PaycodesDistributionsRepository
    public punch_match: PunchMatchRepository
    public punch: PunchRepository
    public totalize: TotalizeRepository
    public rounding_rules: RoundingRulesRepo
    public paycodes_combination: PaycodesCombinationRepository

    public accrual_code: AccrualCodeRepository
    public accrual_date: AccrualDateRepository
    public date_pattern: DatePatternRepository
    public balance_domino: BalanceDominoRepository
    public group_balance: GroupBalanceRepository
    public grants: GrantRepository
    public limits: LimitRepository
    public accrual_rule: AccrualRuleRepository
    public accrual_profile: AccrualProfileRepository
    public employee_accrual_profile: EmployeeAccrualProfileRepository
    public config_system: ConfigSystemRepository



    constructor(url?: string) {
        this.cacheService = new CacheService('tk-cache-db');
        const baseURL = url ? url : `${process.env.REACT_APP_TK_GW_DOMAIN}/v1/timekeeper`;

        const apiClient = createApiClient(baseURL)
        this.httpTKService = new AxiosHttpService(apiClient, this.cacheService);

        const apiAccrualClient = createApiClient(`${baseURL}/accruals`)
        this.httpAccrualService = new AxiosHttpService(apiAccrualClient, this.cacheService);

        const baseURLMDMPSC = url ? url : `${process.env.REACT_APP_TK_GW_DOMAIN}/v1/mdm_psc`;
        const apiClientMDMPSC = createApiClient(baseURLMDMPSC)
        this.httpPunchService = new AxiosHttpService(apiClientMDMPSC, this.cacheService);


        this.break_rule = new BreakRuleRepository(this.httpTKService);
        this.combination_rule = new CombinationRuleRepository(this.httpTKService);
        this.credit_holiday_rule = new CreditHolidayRuleRepo(this.httpTKService);
        this.fixed_rule = new FixedRuleRepo(this.httpTKService);
        this.holiday = new HolidayRepository(this.httpTKService);
        this.interpretation_rules = new InterpretationRulesRepository(this.httpTKService);
        this.zones = new ZoneRepo(this.httpTKService);
        this.work_rules = new WorkRuleRepository(this.httpTKService);
        this.schedule_desviation = new ScheduleDesviationRepo(this.httpTKService);
        this.paycodes = new PaycodeRepository(this.httpTKService);
        this.overtime = new OvertimeRepository(this.httpTKService);
        this.payrules = new PayRuleRepository(this.httpTKService);
        this.bonus_rules = new BonusRuleRepository(this.httpTKService);
        this.exception_rules = new ExceptionRuleRepo(this.httpTKService);
        this.paycode_distributions = new PaycodesDistributionsRepository(this.httpTKService);
        this.punch_match = new PunchMatchRepository(this.httpTKService);
        this.punch = new PunchRepository(this.httpPunchService);
        this.totalize = new TotalizeRepository(this.httpTKService);
        this.rounding_rules = new RoundingRulesRepo(this.httpTKService);
        this.paycodes_combination = new PaycodesCombinationRepository(this.httpTKService);


        this.accrual_code = new AccrualCodeRepository(this.httpAccrualService);
        this.accrual_date = new AccrualDateRepository(this.httpAccrualService);
        this.date_pattern = new DatePatternRepository(this.httpAccrualService);
        this.balance_domino = new BalanceDominoRepository(this.httpAccrualService);
        this.group_balance = new GroupBalanceRepository(this.httpAccrualService);
        this.grants = new GrantRepository(this.httpAccrualService);
        this.limits = new LimitRepository(this.httpAccrualService);
        this.accrual_rule = new AccrualRuleRepository(this.httpAccrualService);
        this.accrual_profile = new AccrualProfileRepository(this.httpAccrualService);
        this.employee_accrual_profile = new EmployeeAccrualProfileRepository(this.httpAccrualService);
        this.config_system = new ConfigSystemRepository(this.httpTKService);
    }

}